<slotcom-navigation-button
  type="close"
  (click)="closeModal()">
</slotcom-navigation-button>

<div class="c-promoCodeRedeemedModal">
  <div class="c-promoCodeRedeemedModal__image">
    <div class="c-promoCodeRedeemedModal__title">
      <span>{{ 'home.lobby.modals.promo-code-redeemed.title' | translate }}</span>
    </div>

    <div class="c-promoCodeRedeemedModal__subtitle">
      <span>{{ 'home.lobby.modals.promo-code-redeemed.subtitle' | translate }}</span>
    </div>

    <slotcom-button
      class="c-button--pink"
      (safeClick)="goToShop()"
      audioType="functionality">
      {{ 'home.buttons.go-to-store' | translate | uppercase }}
    </slotcom-button>
  </div>
</div>
